import React, { useEffect, useState } from "react";
import "./Css/QuestionView.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import API_BASE from "../config/api";

const QuestionView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const API_BASE_URL = `${API_BASE}`;

  const [data, setData] = useState(null);

  const handleEditClick = () => {
    navigate(`/dashboard/queedit/${id}`);
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/questions/${id}`, {

        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      },

      )
      .then(res => setData(res.data))
      .catch(err => {
        console.error(err);
        alert("Failed to load question");
      });
  }, [id]);

  if (!data) return <div className="question-view-wrapper">Loading...</div>;

  return (
    <div className="question-view-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          प्रश्न संच &gt;&gt; <span>विद्यार्थी तपशील</span>
        </h3>
        <button className="edit-btn" onClick={handleEditClick}>
          एडिट करा
        </button>
      </div>

      <div className="filter-bar">
        <div className="filter">{data.softwareName}</div>
        {/* <div className="filter">{data.questionType}</div> */}
        <div className="filter">{data.standard || "-"}</div>
        <div className="filter">{data.subjectName}</div>
      </div>

      <div className="content-area">
        <div className="left-panel">
          <h4>प्रश्न तपशील</h4>

          <label>घटक</label>
          <input type="text" value={data.topic} disabled readOnly />

          <label>उपघटक</label>
          <input type="text" value={data.subTopic} disabled readOnly />

          <label>गुण</label>
          <input type="text" value={data.mark} disabled readOnly />

          <label>प्रश्न</label>
          <input type="text" value={data.questionText} disabled readOnly />

          {data.questionImageUrl && (
            <img
              src={`${API_BASE_URL}${data.questionImageUrl}`}
              alt="question"
              className="question-image"
            />
          )}

          <label>पर्याय ०१</label>
          <input type="text" value={data.optionA} disabled readOnly />

          {data.optionAImageUrl && (
            <img
              src={`${API_BASE_URL}${data.optionAImageUrl}`}
              alt="optionA"
              className="option-image"
            />
          )}

          <label>पर्याय ०२</label>
          <input type="text" value={data.optionB} disabled readOnly />

          {data.optionBImageUrl && (
            <img
              src={`${API_BASE_URL}${data.optionBImageUrl}`}
              alt="optionB"
              className="option-image"
            />
          )}

          <label>पर्याय ०३</label>
          <input type="text" value={data.optionC} disabled readOnly />

          {data.optionCImageUrl && (
            <img
              src={`${API_BASE_URL}${data.optionCImageUrl}`}
              alt="optionC"
              className="option-image"
            />
          )}

          <label>पर्याय ०४</label>
          <input type="text" value={data.optionD} disabled readOnly />

          {data.optionDImageUrl && (
            <img
              src={`${API_BASE_URL}${data.optionDImageUrl}`}
              alt="optionD"
              className="option-image"
            />
          )}

          <label>बरोबर उत्तर</label>
          <input
            type="text"
            className="correct-answer"
            value={data.correctAnswer + " ✅"}
            disabled
            readOnly
          />

          <label>प्रश्न पातळी</label>
          <input type="text" value={data.difficultyLevel} disabled readOnly />

          <label>निर्मिती (created by)</label>
          <input type="text" value={data.softwareName} disabled readOnly />
        </div>
      </div>
    </div>
  );
};

export default QuestionView;
